import { render } from "./administrators.vue?vue&type=template&id=78b0a22a&scoped=true"
import script from "./administrators.vue?vue&type=script&lang=js"
export * from "./administrators.vue?vue&type=script&lang=js"

import "./administrators.vue?vue&type=style&index=0&id=78b0a22a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b0a22a"]])

export default __exports__